import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  TextField,
  DialogContent,
  Divider,
  Grid,
  DialogActions,
  Button,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Paper,
} from "@material-ui/core";
import * as React from "react";
import { blue } from "@material-ui/core/colors";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  DAYS_OF_MONTH,
  FREQUENCIES,
  REPEAT_FREQUENCIES,
  getCategories,
  getInspectionLabel,
} from "../constants/constants";
import moment from "moment";
import AddCustomScheduleDialog from "./AddCustomScheduleDialog";
import DisplayWeekDaysComponent from "../../app/components/DisplayWeekDaysComponent";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: blue[100],
      color: blue[600],
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });

interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  onClose: any;
  companyData: any;
  onSchedulerSubmitted: any;
  editData: any;
}
class AddScheduleDialog extends React.Component<Props> {
  state = {
    inspectionType: { value: "", label: "" },
    category: { value: "", label: "" },
    onceOff: false,
    recurring: false,
    frequency: {
      type: "",
      time: new Date(),
      day: "",
      custom: {
        repeatNumber: 1,
        repeatFrequency: "",
        day: "",
        time: new Date(),
      },
    },
    startDateTime: new Date(),
    executionTime: new Date(),
    showCustomDialog: false,
  };

  componentDidMount = () => {
    this.populateDefault();
  };

  componentDidUpdate = (prevProv: any, prevState: any) => {
    const { editData } = this.props;
    if (prevProv.editData !== editData) {
      this.populateDefault();
    }
  };

  populateDefault = () => {
    const { editData } = this.props;
    this.setState({
      inspectionType: editData.inspectionType
        ? editData.inspectionType
        : { value: "", label: "" },
      category: editData.category
        ? editData.category
        : { value: "", label: "" },
      onceOff: editData.onceOff ? editData.onceOff : false,
      recurring: editData.recurring ? editData.recurring : false,
      frequency: editData.frequency
        ? editData.frequency
        : {
            type: "",
            time: new Date(),
            day: "",
            custom: {
              repeatNumber: 1,
              repeatFrequency: "",
              day: "",
              time: new Date(),
            },
          },
      startDateTime: editData.startDateTime
        ? new Date(editData.startDateTime)
        : new Date(),
      executionTime: editData.executionTime
        ? new Date(editData.executionTime)
        : new Date(),
    });
  };

  reset = () => {
    this.setState({
      inspectionType: { value: "", label: "" },
      category: { value: "", label: "" },
      onceOff: false,
      recurring: false,
      frequency: {
        type: "",
        time: new Date(),
        day: "",
        custom: {
          repeatNumber: 1,
          repeatFrequency: "",
          day: "",
          time: new Date(),
        },
      },
      startDateTime: new Date(),
      executionTime: new Date(),
      showCustomDialog: false,
    });
  };

  renderCustomDialog = () => {
    return (
      <AddCustomScheduleDialog
        open={this.state.showCustomDialog}
        onClose={() => {
          this.setState({
            showCustomDialog: false,
          });
        }}
        dialogTitle={`Add Custom recurrence`}
      />
    );
  };

  render() {
    const { open, dialogTitle, onClose, companyData, onSchedulerSubmitted } =
      this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => onClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
          <Divider />
          <DialogContent>
            <div style={{ width: "100%", margin: 10 }}>
              {companyData && companyData.inspectionTypes && (
                <TextField
                  select
                  label={"Inspection Type"}
                  margin="dense"
                  value={this.state.inspectionType.value}
                  onChange={(event) => {
                    let currentinspectionType = this.state.inspectionType;
                    currentinspectionType = getInspectionLabel(
                      event.target.value,
                      companyData.inspectionTypes
                    );
                    this.setState({
                      inspectionType: currentinspectionType,
                    });
                  }}
                  fullWidth
                >
                  {companyData.inspectionTypes.map(
                    (option: any, index: any) => (
                      <MenuItem key={index.toString()} value={option.value}>
                        {option.label}
                      </MenuItem>
                    )
                  )}
                </TextField>
              )}
              {companyData && companyData.inspectionTypes && (
                <TextField
                  select
                  label={"Inspection Category"}
                  margin="dense"
                  value={this.state.category.value}
                  onChange={(event) => {
                    let currentinspectionCategoryValue = this.state.category;
                    currentinspectionCategoryValue = getInspectionLabel(
                      event.target.value,
                      getCategories(
                        companyData.inspectionTypes,
                        this.state.inspectionType.value
                      )
                    );
                    this.setState({
                      category: currentinspectionCategoryValue,
                    });
                  }}
                  fullWidth
                >
                  {getCategories(
                    companyData.inspectionTypes,
                    this.state.inspectionType.value
                  ).map((option: any, index: any) => (
                    <MenuItem key={index.toString()} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              )}
              <div style={{ display: "flex", flexDirection: "row" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.onceOff}
                      onChange={(event: any) => {
                        this.setState({
                          onceOff: event.target.checked,
                          recurring: false,
                        });
                      }}
                      name="OnceOff"
                      color="primary"
                    />
                  }
                  label="Once off"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.recurring}
                      onChange={(event: any) =>
                        this.setState({
                          recurring: event.target.checked,
                          onceOff: false,
                        })
                      }
                      name="Recurring"
                      color="primary"
                    />
                  }
                  label="Recurring"
                />
              </div>
              {this.state.onceOff && (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",

                      alignItems: "center",
                    }}
                  >
                    <Grid container style={{ justifyContent: "space-between" }}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="dd MMM yyyy"
                        margin="normal"
                        autoOk={true}
                        id="completionDate"
                        label={"Start date"}
                        value={this.state.startDateTime}
                        onChange={(event: any) => {
                          this.setState({
                            startDateTime: new Date(event.getTime()),
                          });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                      <KeyboardTimePicker
                        disableToolbar
                        variant="inline"
                        margin="normal"
                        autoOk={true}
                        ampm={false}
                        id="completionDate"
                        label="Execution Time"
                        value={this.state.executionTime}
                        onChange={(event: any) => {
                          this.setState({
                            executionTime: new Date(event.getTime()),
                          });
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </Grid>
                  </div>
                </MuiPickersUtilsProvider>
              )}
              {this.state.recurring && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection:
                        this.state.frequency.type === "DAILY"
                          ? "row"
                          : "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <TextField
                      style={{ marginRight: 10 }}
                      select
                      label={"Frequency"}
                      value={this.state.frequency.type}
                      onChange={(event) => {
                        let frequency = this.state.frequency;
                        frequency.type = event.target.value;
                        this.setState({
                          frequency,
                        });
                      }}
                      fullWidth
                    >
                      {FREQUENCIES.map((option: any, index: any) => (
                        <MenuItem key={index.toString()} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <div>
                      {this.state.frequency.type === "DAILY" && (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <Grid container>
                            <KeyboardTimePicker
                              id="time-picker"
                              label="Execution Time"
                              value={this.state.frequency.time}
                              onChange={(event: any) => {
                                let frequency = this.state.frequency;
                                frequency.time = new Date(event.getTime());
                                this.setState({
                                  frequency,
                                });
                              }}
                              KeyboardButtonProps={{
                                "aria-label": "change time",
                              }}
                            />
                          </Grid>
                        </MuiPickersUtilsProvider>
                      )}
                      {this.state.frequency.type === "WEEKLY" && (
                        <div style={{ marginTop: 10 }}>
                          <DisplayWeekDaysComponent
                            currentSelected={this.state.frequency.day}
                            onSelectedDay={(selectedDay: any) => {
                              let frequency = this.state.frequency;
                              frequency.day = selectedDay;
                              this.setState({
                                frequency,
                              });
                            }}
                          />
                          <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Grid container>
                                <KeyboardTimePicker
                                  id="time-picker"
                                  label="Execution Time"
                                  value={this.state.frequency.time}
                                  onChange={(event: any) => {
                                    this.setState({
                                      selectedTime: new Date(event.getTime()),
                                    });
                                  }}
                                  KeyboardButtonProps={{
                                    "aria-label": "change time",
                                  }}
                                />
                              </Grid>
                            </MuiPickersUtilsProvider>
                          </div>
                        </div>
                      )}
                      {this.state.frequency.type === "MONTHLY" && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginRight: 10,
                            marginTop: 10,
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <TextField
                            style={{ width: 100 }}
                            select
                            label={"Day of Month"}
                            value={this.state.frequency.day}
                            onChange={(event) => {
                              let frequency = this.state.frequency;
                              frequency.day = event.target.value;
                              this.setState({
                                frequency,
                              });
                            }}
                          >
                            {DAYS_OF_MONTH.map((option: any, index: any) => (
                              <MenuItem key={index.toString()} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </TextField>
                          <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Grid container>
                                <KeyboardTimePicker
                                  id="time-picker"
                                  label="Execution Time"
                                  value={this.state.frequency.time}
                                  onChange={(event: any) => {
                                    let frequency = this.state.frequency;
                                    frequency.time = new Date(event.getTime());
                                    this.setState({
                                      frequency,
                                    });
                                  }}
                                  KeyboardButtonProps={{
                                    "aria-label": "change time",
                                  }}
                                />
                              </Grid>
                            </MuiPickersUtilsProvider>
                          </div>
                        </div>
                      )}
                      {this.state.frequency.type === "CUSTOM" && (
                        <div
                          style={{
                            display: "flex",
                            marginTop: 10,
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                              flexDirection: "row",
                            }}
                          >
                            <TextField
                              style={{ width: "50%", marginRight: 10 }}
                              label={"Repeat every"}
                              value={this.state.frequency.custom.repeatNumber}
                              onChange={(event) => {
                                let frequency = this.state.frequency;
                                let custom = frequency.custom;
                                custom.repeatNumber = Number(
                                  event.target.value
                                );
                                this.setState({
                                  frequency,
                                });
                              }}
                            ></TextField>
                            <TextField
                              style={{ width: "50%", marginLeft: 10 }}
                              select
                              label={"By"}
                              value={
                                this.state.frequency.custom.repeatFrequency
                              }
                              onChange={(event) => {
                                let frequency = this.state.frequency;
                                let custom = frequency.custom;
                                custom.repeatFrequency = event.target.value;
                                this.setState({
                                  frequency,
                                });
                              }}
                              fullWidth
                            >
                              {REPEAT_FREQUENCIES.map(
                                (option: any, index: any) => (
                                  <MenuItem
                                    key={index.toString()}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </MenuItem>
                                )
                              )}
                            </TextField>
                            {this.state.frequency.custom.repeatFrequency ===
                              "DAY" && (
                              <div style={{ width: "50%", marginLeft: 10 }}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <Grid container>
                                    <KeyboardTimePicker
                                      id="time-picker"
                                      label="Execution Time"
                                      value={this.state.frequency.custom.time}
                                      onChange={(event: any) => {
                                        let frequency = this.state.frequency;
                                        let custom = frequency.custom;
                                        custom.time = new Date(event.getTime());
                                        this.setState({
                                          frequency,
                                        });
                                      }}
                                      KeyboardButtonProps={{
                                        "aria-label": "change time",
                                      }}
                                    />
                                  </Grid>
                                </MuiPickersUtilsProvider>
                              </div>
                            )}
                          </div>
                          {this.state.frequency.custom.repeatFrequency ===
                            "WEEK" && (
                            <div>
                              <DisplayWeekDaysComponent
                                currentSelected={
                                  this.state.frequency.custom.day
                                }
                                onSelectedDay={(selectedDay: any) => {
                                  let frequency = this.state.frequency;
                                  let custom = frequency.custom;
                                  custom.day = selectedDay;
                                  this.setState({});
                                }}
                              />
                              <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <Grid container>
                                    <KeyboardTimePicker
                                      id="time-picker"
                                      label="Execution Time"
                                      value={this.state.frequency.custom.time}
                                      onChange={(event: any) => {
                                        let frequency = this.state.frequency;
                                        let custom = frequency.custom;
                                        custom.time = new Date(event.getTime());
                                        this.setState({
                                          frequency,
                                        });
                                      }}
                                      KeyboardButtonProps={{
                                        "aria-label": "change time",
                                      }}
                                    />
                                  </Grid>
                                </MuiPickersUtilsProvider>
                              </div>
                            </div>
                          )}
                          {this.state.frequency.custom.repeatFrequency ===
                            "MONTH" && (
                            <div
                              style={{
                                display: "flex",
                                marginTop: 10,
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <TextField
                                style={{ width: 150 }}
                                select
                                label={"Day of Month"}
                                value={this.state.frequency.custom.day}
                                onChange={(event) => {
                                  let frequency = this.state.frequency;
                                  let custom = frequency.custom;
                                  custom.day = event.target.value;
                                  this.setState({
                                    frequency,
                                  });
                                }}
                              >
                                {DAYS_OF_MONTH.map(
                                  (option: any, index: any) => (
                                    <MenuItem
                                      key={index.toString()}
                                      value={option}
                                    >
                                      {option}
                                    </MenuItem>
                                  )
                                )}
                              </TextField>
                              <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <Grid container>
                                    <KeyboardTimePicker
                                      id="time-picker"
                                      label="Execution Time"
                                      value={this.state.frequency.custom.time}
                                      onChange={(event: any) => {
                                        let frequency = this.state.frequency;
                                        let custom = frequency.custom;
                                        custom.time = new Date(event.getTime());
                                        this.setState({
                                          frequency,
                                        });
                                      }}
                                      KeyboardButtonProps={{
                                        "aria-label": "change time",
                                      }}
                                    />
                                  </Grid>
                                </MuiPickersUtilsProvider>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <Divider />
                    <Paper style={{ width: "100%", padding: 5 }}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-between">
                          <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="dd MMM yyyy"
                            margin="normal"
                            autoOk={true}
                            label={"Start date"}
                            value={this.state.startDateTime}
                            onChange={(event: any) => {
                              let mDate = moment
                                .utc(new Date(event.toString()))
                                .local(false);
                              this.setState({
                                startDateTime: mDate.toISOString(),
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </Paper>
                  </div>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                onClose();
              }}
            >
              {"CANCEL"}
            </Button>
            <Button
              type="submit"
              onClick={() => {
                const {
                  inspectionType,
                  category,
                  onceOff,
                  recurring,
                  frequency,
                  startDateTime,
                  executionTime,
                } = { ...this.state };
                this.reset();
                onSchedulerSubmitted({
                  inspectionType,
                  category,
                  onceOff,
                  recurring,
                  frequency,
                  startDateTime,
                  executionTime,
                  scheduled: false,
                });
              }}
            >
              {"SAVE"}
            </Button>
          </DialogActions>
        </Dialog>
        {this.renderCustomDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddScheduleDialog);
